import { buttonAbi } from "./contractAbi/buttonAbi";

export default {
  stand: process.env.REACT_APP_STAND,
  allowedChainId: process.env.REACT_APP_ALLOWED_CHAIN_ID,
  buttonContract: process.env.REACT_APP_BUTTON_CONTRACT,

  buttonContractAbi: buttonAbi,
};
